// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 메인 콘텐츠 영역 */
.mainContent {
  padding: 20px;
  background-color: white;
}

/* 헤더 섹션 */
.headerSection {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-right: 20px;
}

.nameAndEditSection {
  display: flex;
  align-items: center;
  gap: 200px;
}

.workerName {
  margin: 0;
  display: flex;
  align-items: center;
}

.namePart {
  color: #ff6b00;
  font-size: 24px;
}

.nimPart {
  color: #333;
  font-size: 24px;
}

.editInfoButton, .exportButton {
  padding: 8px 16px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-right: 100px;
}

.buttonIcon {
  margin-right: 5px;
}

/* 메인 레이아웃 */
.detailLayout {
  display: flex;
  gap: 0;
  justify-content: space-between;
}

/* 왼쪽 섹션 - 정보 및 요약 */
.leftSection {
  flex: 0 0 400px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-right: 20px;
}

/* 정보 테이블 - 너비 고정 */
.infoTable {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 420px; /* 고정 너비 설정 */
}

.infoRow {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
}

.infoRow:last-child {
  border-bottom: none;
}

.infoLabel {
  width: 150px;
  padding: 12px 15px;
  background-color: #fde9d9;
  font-weight: normal;
}

.infoValue {
  flex: 1 1;
  padding: 12px 15px;
  text-align: right;
}

/* 월별 근무 요약 */
.monthlySummary {
  margin-bottom: 20px;
}

/* 월별 근무 요약 제목 */
.summaryTitle {
  margin-top: 80px;
  margin-bottom: 0px;
  font-size: 18px;
  color: #333;
}

/* 요약 테이블 - 너비 확장 */
.summaryTable {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 500px; /* 600px에서 500px로 조정 */
  margin-top: 10px;
  position: relative; /* 위치 설정을 위해 추가 */
  left: 0px; /* -100px에서 -50px로 조정하여 덜 왼쪽으로 이동 */
  z-index: 1; /* 다른 요소 위에 표시되도록 z-index 추가 */
}

.summaryRow {
  display: flex;
  margin-bottom: 15px;
  align-items: center;
}

.summaryRow:last-child {
  margin-bottom: 0;
}

/* summaryLabel과 summaryValue에 대한 스타일 */
.summaryLabel {
  width: 100px;
  font-size: 16px;
  color: #333;
  background-color: white !important;
  font-weight: bold;
  white-space: nowrap;
  text-align: left;
}

.summaryValue {
  width: 100px;
  font-size: 16px;
  white-space: nowrap;
  text-align: right;
  display: inline-block;
  min-width: 50px;
}

.divider {
  width: 2px;
  height: 25px;
  background-color: #ddd;
  margin: 0 15px; /* 20px에서 15px로 조정 */
}

.overtimeHours {
  color: #ff6b00;
  margin-left: 5px;
  font-weight: bold;
}

.totalLabel {
  font-weight: bold;
  color: #ff6b00;
  font-size: 18px;
}

.totalValue {
  color: #ff6b00;
  font-weight: bold;
  font-size: 18px;
}

/* 오른쪽 섹션 - 달력 */
.rightSection {
  flex: 0 0 50%;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.halfCalendar {
  width: 100%;
}

.calendar {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-right: 100px;
}

.calendarHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.monthNavButton {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #888;
  padding: 5px 10px;
}

.calendarTitle {
  margin: 0 15px;
  font-size: 18px;
  font-weight: normal;
}

.weekdayHeader {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
}

.weekday {
  font-size: 14px;
  font-weight: bold;
}

.sunday {
  color: #ff5555;
}

.saturday {
  color: #5555ff;
}

.calendarBody {
  padding: 8px;
}

.weekRow {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-bottom: 8px;
}

.day {
  min-height: 70px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 3px;
  position: relative;
}

.dayNumber {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 2px;
}

.dayNumber.today {
  background-color: #ff6b00;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dayContent {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hoursTag {
  display: inline-block;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: normal;
  margin-bottom: 2px;
}

.hoursTag.normal {
  background-color: #e7f7e7;
  color: #00a000;
}

.hoursTag.lateOrEarly {
  background-color: #ffe0e0;
  color: #ff0000;
}

/* 공휴일 스타일 */
.dayNumber.holiday {
  color: #e53935;
  font-weight: bold;
}

.holidayName {
  font-size: 10px;
  color: #e53935;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* 기존 상태별 스타일은 유지하되 배경색은 normal/lateOrEarly로 컨트롤함 */
.hoursTag.출근, .hoursTag.지각, .hoursTag.조퇴 {
  /* 공통 스타일만 유지 */
  display: inline-block;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: normal;
  margin-bottom: 2px;
}

.statusText {
  font-size: 11px;
  margin-bottom: 2px;
}

.statusDetail {
  font-size: 11px;
  color: #888;
  margin-bottom: 2px;
}

.payAmount {
  font-size: 11px;
  color: #444;
}

/* 반응형 스타일 */
@media (max-width: 900px) {
  .detailLayout {
    flex-direction: column;
  }
  
  .leftSection {
    flex: none;
    width: 100%;
  }
}

@media (max-width: 600px) {
  .headerSection {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .nameAndEditSection {
    width: 100%;
    justify-content: space-between;
  }
  
  .summaryRow {
    flex-wrap: wrap;
  }
  
  .divider {
    display: none;
  }
}

/* 편집 모드 입력 필드 스타일 */
.editInput {
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  text-align: right;
  background-color: #f9f9f9;
}

.editInput:focus {
  outline: none;
  border-color: #ff6b00;
  box-shadow: 0 0 0 2px rgba(255, 107, 0, 0.1);
}

/* 임금 입력 필드 스타일 */
.salaryInputWrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.salaryPrefix {
  margin-right: 5px;
  color: #555;
}

.salarySuffix {
  margin-left: 5px;
  color: #555;
}

.salaryInput {
  width: 120px;
}

/* 공지사항 선택 박스 스타일 */
.noticeSelect {
  width: auto;
  min-width: 60px;
}

/* 정보 수정하기 버튼 스타일 (이 스타일을 기준으로) */
.editInfoButton {
  padding: 8px 16px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-right: 100px;
  font-size: 14px;
  width: 140px; /* 고정 너비 설정 */
  height: 36px; /* 고정 높이 설정 */
}

.buttonIcon {
  margin-right: 5px;
}

/* 수정완료 버튼 스타일 (정보 수정하기 버튼과 완전히 동일한 크기로) */
.saveButton {
  /* 정보 수정하기 버튼과 완전히 동일한 속성 복사 */
  padding: 8px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-right: 100px;
  font-size: 14px;
  width: 140px; /* 정확히 같은 너비 */
  height: 36px; /* 정확히 같은 높이 */
  
  /* 수정완료 버튼만의 스타일 */
  background-color: #ff6b00;
  color: white;
  border: none;
  justify-content: center;
}

.okIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  min-width: 20px; /* 최소 너비 설정 */
  background-color: white;
  color: #ff6b00;
  border-radius: 2px;
  margin-right: 8px;
  font-weight: bold;
  font-size: 12px;
}

/* 정보 수정하기 버튼 스타일 */
.editInfoButton:hover {
  background-color: #f5f5f5;
}

/* 편집 모드일 때 버튼 스타일 */
.editInfoButton.active {
  background-color: #ff6b00;
  color: white;
  border-color: #ff6b00;
}

.editInfoButton.active:hover {
  background-color: #e05f00;
}

.dataSection {
  margin-top: 20px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: auto;
}

.jsonData {
  font-family: monospace;
  font-size: 12px;
  white-space: pre-wrap;
  max-height: 300px;
  overflow: auto;
}

/* 여기에 초과근로시간 표시 스타일 추가 */
.overtimeDisplay {
  color: #ff6b00;
  font-size: 0.85em;
  margin-left: 2px;
}

/* 시간 태그 스타일 */
.hoursTag {
  display: inline-block;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: normal;
  margin-bottom: 2px;
}

.hoursTag.출근, .hoursTag.정상출근 {
  background-color: #e3f2fd;
  color: #1976d2;
}

.hoursTag.지각, .hoursTag.자각 {
  background-color: #fff3e0;
  color: #e65100;
}

.hoursTag.조퇴, .hoursTag.정상퇴근 {
  background-color: #ffebee;
  color: #c62828;
}

/* 수당 값에 대한 추가 간격 */
.summarySpaced {
  margin-left: 10px;
  text-align: right;
  min-width: 100px;
}

/* 왼쪽 영역의 값도 일관된 스타일 적용 */
.summaryRow:nth-child(1) .summaryValue:nth-child(2),
.summaryRow:nth-child(2) .summaryValue:nth-child(2),
.summaryRow:nth-child(3) .summaryValue:nth-child(2),
.summaryRow:nth-child(4) .summaryValue:nth-child(2) {
  width: 50px;
  text-align: right;
  padding-right: 10px;
  display: inline-block;
}

/* 오른쪽 영역의 수당 값 스타일 통일 */
.summaryRow:nth-child(1) .summaryValue:nth-child(5),
.summaryRow:nth-child(2) .summaryValue:nth-child(5),
.summaryRow:nth-child(3) .summaryValue:nth-child(5),
.summaryRow:nth-child(4) .summaryValue:nth-child(5) {
  min-width: 100px;
  text-align: right;
  padding-right: 0;
} `, "",{"version":3,"sources":["webpack://./src/styles/WorkerDetail.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,MAAM;EACN,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,YAAY,EAAE,aAAa;AAC7B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,YAAY,EAAE,sBAAsB;EACpC,gBAAgB;EAChB,kBAAkB,EAAE,iBAAiB;EACrC,SAAS,EAAE,mCAAmC;EAC9C,UAAU,EAAE,8BAA8B;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,YAAY,EAAE,aAAa;EAC3B,YAAY,EAAE,aAAa;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,YAAY,EAAE,cAAc;EAC5B,YAAY,EAAE,cAAc;;EAE5B,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe,EAAE,aAAa;EAC9B,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;;;;EAIE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* 메인 콘텐츠 영역 */\n.mainContent {\n  padding: 20px;\n  background-color: white;\n}\n\n/* 헤더 섹션 */\n.headerSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-right: 20px;\n}\n\n.nameAndEditSection {\n  display: flex;\n  align-items: center;\n  gap: 200px;\n}\n\n.workerName {\n  margin: 0;\n  display: flex;\n  align-items: center;\n}\n\n.namePart {\n  color: #ff6b00;\n  font-size: 24px;\n}\n\n.nimPart {\n  color: #333;\n  font-size: 24px;\n}\n\n.editInfoButton, .exportButton {\n  padding: 8px 16px;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-right: 100px;\n}\n\n.buttonIcon {\n  margin-right: 5px;\n}\n\n/* 메인 레이아웃 */\n.detailLayout {\n  display: flex;\n  gap: 0;\n  justify-content: space-between;\n}\n\n/* 왼쪽 섹션 - 정보 및 요약 */\n.leftSection {\n  flex: 0 0 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-right: 20px;\n}\n\n/* 정보 테이블 - 너비 고정 */\n.infoTable {\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  width: 420px; /* 고정 너비 설정 */\n}\n\n.infoRow {\n  display: flex;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.infoRow:last-child {\n  border-bottom: none;\n}\n\n.infoLabel {\n  width: 150px;\n  padding: 12px 15px;\n  background-color: #fde9d9;\n  font-weight: normal;\n}\n\n.infoValue {\n  flex: 1;\n  padding: 12px 15px;\n  text-align: right;\n}\n\n/* 월별 근무 요약 */\n.monthlySummary {\n  margin-bottom: 20px;\n}\n\n/* 월별 근무 요약 제목 */\n.summaryTitle {\n  margin-top: 80px;\n  margin-bottom: 0px;\n  font-size: 18px;\n  color: #333;\n}\n\n/* 요약 테이블 - 너비 확장 */\n.summaryTable {\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  width: 500px; /* 600px에서 500px로 조정 */\n  margin-top: 10px;\n  position: relative; /* 위치 설정을 위해 추가 */\n  left: 0px; /* -100px에서 -50px로 조정하여 덜 왼쪽으로 이동 */\n  z-index: 1; /* 다른 요소 위에 표시되도록 z-index 추가 */\n}\n\n.summaryRow {\n  display: flex;\n  margin-bottom: 15px;\n  align-items: center;\n}\n\n.summaryRow:last-child {\n  margin-bottom: 0;\n}\n\n/* summaryLabel과 summaryValue에 대한 스타일 */\n.summaryLabel {\n  width: 100px;\n  font-size: 16px;\n  color: #333;\n  background-color: white !important;\n  font-weight: bold;\n  white-space: nowrap;\n  text-align: left;\n}\n\n.summaryValue {\n  width: 100px;\n  font-size: 16px;\n  white-space: nowrap;\n  text-align: right;\n  display: inline-block;\n  min-width: 50px;\n}\n\n.divider {\n  width: 2px;\n  height: 25px;\n  background-color: #ddd;\n  margin: 0 15px; /* 20px에서 15px로 조정 */\n}\n\n.overtimeHours {\n  color: #ff6b00;\n  margin-left: 5px;\n  font-weight: bold;\n}\n\n.totalLabel {\n  font-weight: bold;\n  color: #ff6b00;\n  font-size: 18px;\n}\n\n.totalValue {\n  color: #ff6b00;\n  font-weight: bold;\n  font-size: 18px;\n}\n\n/* 오른쪽 섹션 - 달력 */\n.rightSection {\n  flex: 0 0 50%;\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n}\n\n.halfCalendar {\n  width: 100%;\n}\n\n.calendar {\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  margin-right: 100px;\n}\n\n.calendarHeader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px 15px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.monthNavButton {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #888;\n  padding: 5px 10px;\n}\n\n.calendarTitle {\n  margin: 0 15px;\n  font-size: 18px;\n  font-weight: normal;\n}\n\n.weekdayHeader {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n  padding: 15px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.weekday {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.sunday {\n  color: #ff5555;\n}\n\n.saturday {\n  color: #5555ff;\n}\n\n.calendarBody {\n  padding: 8px;\n}\n\n.weekRow {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.day {\n  min-height: 70px;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  padding: 3px;\n  position: relative;\n}\n\n.dayNumber {\n  font-size: 12px;\n  font-weight: bold;\n  margin-bottom: 2px;\n}\n\n.dayNumber.today {\n  background-color: #ff6b00;\n  color: white;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dayContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.hoursTag {\n  display: inline-block;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-size: 11px;\n  font-weight: normal;\n  margin-bottom: 2px;\n}\n\n.hoursTag.normal {\n  background-color: #e7f7e7;\n  color: #00a000;\n}\n\n.hoursTag.lateOrEarly {\n  background-color: #ffe0e0;\n  color: #ff0000;\n}\n\n/* 공휴일 스타일 */\n.dayNumber.holiday {\n  color: #e53935;\n  font-weight: bold;\n}\n\n.holidayName {\n  font-size: 10px;\n  color: #e53935;\n  text-align: center;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n/* 기존 상태별 스타일은 유지하되 배경색은 normal/lateOrEarly로 컨트롤함 */\n.hoursTag.출근, .hoursTag.지각, .hoursTag.조퇴 {\n  /* 공통 스타일만 유지 */\n  display: inline-block;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-size: 11px;\n  font-weight: normal;\n  margin-bottom: 2px;\n}\n\n.statusText {\n  font-size: 11px;\n  margin-bottom: 2px;\n}\n\n.statusDetail {\n  font-size: 11px;\n  color: #888;\n  margin-bottom: 2px;\n}\n\n.payAmount {\n  font-size: 11px;\n  color: #444;\n}\n\n/* 반응형 스타일 */\n@media (max-width: 900px) {\n  .detailLayout {\n    flex-direction: column;\n  }\n  \n  .leftSection {\n    flex: none;\n    width: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .headerSection {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .nameAndEditSection {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .summaryRow {\n    flex-wrap: wrap;\n  }\n  \n  .divider {\n    display: none;\n  }\n}\n\n/* 편집 모드 입력 필드 스타일 */\n.editInput {\n  width: 100%;\n  padding: 4px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  text-align: right;\n  background-color: #f9f9f9;\n}\n\n.editInput:focus {\n  outline: none;\n  border-color: #ff6b00;\n  box-shadow: 0 0 0 2px rgba(255, 107, 0, 0.1);\n}\n\n/* 임금 입력 필드 스타일 */\n.salaryInputWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.salaryPrefix {\n  margin-right: 5px;\n  color: #555;\n}\n\n.salarySuffix {\n  margin-left: 5px;\n  color: #555;\n}\n\n.salaryInput {\n  width: 120px;\n}\n\n/* 공지사항 선택 박스 스타일 */\n.noticeSelect {\n  width: auto;\n  min-width: 60px;\n}\n\n/* 정보 수정하기 버튼 스타일 (이 스타일을 기준으로) */\n.editInfoButton {\n  padding: 8px 16px;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-right: 100px;\n  font-size: 14px;\n  width: 140px; /* 고정 너비 설정 */\n  height: 36px; /* 고정 높이 설정 */\n}\n\n.buttonIcon {\n  margin-right: 5px;\n}\n\n/* 수정완료 버튼 스타일 (정보 수정하기 버튼과 완전히 동일한 크기로) */\n.saveButton {\n  /* 정보 수정하기 버튼과 완전히 동일한 속성 복사 */\n  padding: 8px 16px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-right: 100px;\n  font-size: 14px;\n  width: 140px; /* 정확히 같은 너비 */\n  height: 36px; /* 정확히 같은 높이 */\n  \n  /* 수정완료 버튼만의 스타일 */\n  background-color: #ff6b00;\n  color: white;\n  border: none;\n  justify-content: center;\n}\n\n.okIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  min-width: 20px; /* 최소 너비 설정 */\n  background-color: white;\n  color: #ff6b00;\n  border-radius: 2px;\n  margin-right: 8px;\n  font-weight: bold;\n  font-size: 12px;\n}\n\n/* 정보 수정하기 버튼 스타일 */\n.editInfoButton:hover {\n  background-color: #f5f5f5;\n}\n\n/* 편집 모드일 때 버튼 스타일 */\n.editInfoButton.active {\n  background-color: #ff6b00;\n  color: white;\n  border-color: #ff6b00;\n}\n\n.editInfoButton.active:hover {\n  background-color: #e05f00;\n}\n\n.dataSection {\n  margin-top: 20px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  overflow: auto;\n}\n\n.jsonData {\n  font-family: monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n  max-height: 300px;\n  overflow: auto;\n}\n\n/* 여기에 초과근로시간 표시 스타일 추가 */\n.overtimeDisplay {\n  color: #ff6b00;\n  font-size: 0.85em;\n  margin-left: 2px;\n}\n\n/* 시간 태그 스타일 */\n.hoursTag {\n  display: inline-block;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-size: 11px;\n  font-weight: normal;\n  margin-bottom: 2px;\n}\n\n.hoursTag.출근, .hoursTag.정상출근 {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.hoursTag.지각, .hoursTag.자각 {\n  background-color: #fff3e0;\n  color: #e65100;\n}\n\n.hoursTag.조퇴, .hoursTag.정상퇴근 {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n/* 수당 값에 대한 추가 간격 */\n.summarySpaced {\n  margin-left: 10px;\n  text-align: right;\n  min-width: 100px;\n}\n\n/* 왼쪽 영역의 값도 일관된 스타일 적용 */\n.summaryRow:nth-child(1) .summaryValue:nth-child(2),\n.summaryRow:nth-child(2) .summaryValue:nth-child(2),\n.summaryRow:nth-child(3) .summaryValue:nth-child(2),\n.summaryRow:nth-child(4) .summaryValue:nth-child(2) {\n  width: 50px;\n  text-align: right;\n  padding-right: 10px;\n  display: inline-block;\n}\n\n/* 오른쪽 영역의 수당 값 스타일 통일 */\n.summaryRow:nth-child(1) .summaryValue:nth-child(5),\n.summaryRow:nth-child(2) .summaryValue:nth-child(5),\n.summaryRow:nth-child(3) .summaryValue:nth-child(5),\n.summaryRow:nth-child(4) .summaryValue:nth-child(5) {\n  min-width: 100px;\n  text-align: right;\n  padding-right: 0;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
